import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@/lib/api";
import { useWorkspaceStore } from "@/stores/workspaceStore";
import type { OrganizationRole } from "@/types/organization.type";
import type { OrgSystemBudget } from "./useOrgSystemBudget";

export type MemberUsage = {
  userId: string;
  name: string;
  email: string;
  role: OrganizationRole;
  limitUsd: number;
  topUpUsd: number;
  spentUsd: number;
  remainingUsd: number;
  exhausted: boolean;
};

export type OrganizationUsage = {
  organization: OrgSystemBudget;
  members: MemberUsage[];
};

/**
 * Owner-only: the workspace system pool plus each member's seat usage this month.
 */
export function useOrganizationUsage(isOwner: boolean) {
  const organizationId = useWorkspaceStore((s) => s.selectedOrganizationId);

  return useQuery({
    queryKey: ["organizationUsage", organizationId],
    queryFn: async () => {
      const res = await axiosInstance.get<OrganizationUsage>(
        `/organization/${organizationId}/usage`,
      );
      return res.data;
    },
    enabled: Boolean(organizationId) && isOwner,
    staleTime: 30_000,
  });
}
